export class ResultadoAprovacaoAditivo {
  ideAditivo: number;
  idSituacaoNova: number;
  erro: string;
}
